// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	/*
	Auto Focus Directive
	*/

	angular.module("swurveys.maker")
		.directive("autoFocus", Handler)

	function Handler($timeout, $exceptionHandler) {
		return {
			restrict: 'A',
			link: function ($scope, $element) {
				$timeout(function () {
					$element[0].focus();
				}, 450);
			}
		}
	}

}());
